import { EquifaxEligibleBuilding } from '../../../helpers/utils/types';
import SVGChecked from '../../../helpers/SVG/SVGRadio/SVGChecked';
import SVGUnchecked from '../../../helpers/SVG/SVGRadio/SVGUnchecked';

type EnableStepProps = {
  properties: EquifaxEligibleBuilding[];
  propertySelectedId: string;
  onSelectProperty: (id: string) => void;
};

const EnableStep = ({ properties, propertySelectedId, onSelectProperty }: EnableStepProps) => (
  <div className='flex flex-col justify-start items-start h-full px-10 py-10'>
    <div className='flex-1 flex items-start justify-start w-full'>
      <div className='flex flex-col items-start justify-between gap-5 w-full h-full'>
        <span className='text-main text-[24px] font-semibold'>Enable reporting</span>
        <span className='text-[#6B7285] text-[13px]'>
          Get started with Credit Builder. Select the home to report first.
        </span>
        <div className='mt-2 grid grid-cols-1 md:grid-cols-2 gap-4 w-full'>
          {properties.map((property) => (
            <button
              type='button'
              className={`rounded-[16px] border bg-white p-5 relative overflow-hidden text-left transition-all shadow-[0px_8px_20px_rgba(17,24,39,0.05)] ${
                propertySelectedId === property?.tenantBuildingId
                  ? 'border-[#0055FF] ring-1 ring-[#0055FF]/20'
                  : 'border-[#E8EAF0] hover:border-[#C5CAD6]'
              }`}
              key={property?.tenantBuildingId}
              onClick={() => onSelectProperty(property?.tenantBuildingId)}
            >
              <div className='absolute -top-8 -right-8 w-32 h-32 rounded-full opacity-10 bg-[#0055FF]' />
              <div className='relative'>
                <div className='flex w-full items-center gap-2'>
                  {propertySelectedId === property?.tenantBuildingId ? <SVGChecked /> : <SVGUnchecked />}
                  <div className='flex flex-col gap-1'>
                    <span className='text-main font-semibold text-base'>{property?.name}</span>
                    <span className='text-light/70 text-sm'>{property?.fullAddress}</span>
                  </div>
                </div>
              </div>
            </button>
          ))}
        </div>
        <div className='mt-2 rounded-[14px] bg-[#F8F9FC] border border-[#E8EAF0] p-5 w-full'>
          <div className='text-[11px] uppercase tracking-[0.08em] text-[#9AA0AE] font-semibold'>
            Powered by
          </div>
          <div className='text-[18px] text-[#B42318] font-semibold mt-0.5'>EQUIFAX</div>
          <div className='mt-4 space-y-2.5 text-[13px] text-[#6B7285]'>
            <div>
              <span className='font-semibold text-[#0A0B14]'>No additional cost:</span> available at no
              cost for TenantPay users who have active rent reporting.
            </div>
            <div>
              <span className='font-semibold text-[#0A0B14]'>Build credit without debt:</span> improve
              score with on-time rent payments.
            </div>
            <div>
              <span className='font-semibold text-[#0A0B14]'>Strengthen rental applications:</span>{' '}
              provide trusted rent history to future landlords.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default EnableStep;
